module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col justify-center items-center relative w-full max-w-2xl"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "px-2 pt-6 pb-6 text-center"
  }, [_c('h2', {
    staticClass: "font-poppins text-xl font-semibold text-gray-900"
  }, [_vm._v("The RoundTable has stopped")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('p', {
    staticClass: "mt-2 text-sm leading-6 text-gray-700"
  }, [_vm._v("\n      Restart to continue the discussion or review the class summary.\n    ")]) : _c('p', {
    staticClass: "mt-4 text-sm text-slate-600"
  }, [_vm._v("\n      Thanks for participating! Take a moment to review the class summary and reflect on your contributions.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 flex flex-col sm:flex-row items-center justify-center gap-2"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-green-700 text-white text-sm font-medium hover:bg-green-800",
    attrs: {
      "type": "button",
      "aria-label": "Restart the discussion"
    },
    on: {
      "click": function($event) {
        return _vm.handleStartVerbal()
      }
    }
  }, [_vm._v("\n        Start discussion\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-full hover:bg-gray-200 text-gray-800 text-sm font-medium border border-gray-200 bg-gray-100",
    attrs: {
      "type": "button",
      "aria-label": "View the class summary"
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeTab('summary')
      }
    }
  }, [_vm._v("\n        View class summary\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-12 w-12 rounded-full bg-white border border-red-500 flex items-center justify-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-stop text-red-500"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-452ca41a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/DiscussionTab/VerbalDiscussionEnded.vue
// module id = 1792
// module chunks = 61